<template>
  <div class="requests">
    <NrTableHeader
      class="requests-table-header"
      :columns="columns"
      :resultCount="allRequestsCount"
      :tableHeaderTitle="tableHeaderTitle"
      :tableHeaderTitleTooltip="tableHeaderTitleTooltip"
      @handleSidebarToggle="toggleFilter"
      @toggleColumnState="toggleColumnState"
      enableColumnFilter
    >
      <template v-slot:count>
        {{ allRequestsCount }}
      </template>
    </NrTableHeader>
    <NrTable
      striped
      tableName="requests"
      class="requests-table"
      :rows="requests"
      :columns="columns"
      :isLoading="isLoading"
      @sort="$emit('sort', $event)"
    >
      <template v-slot:id="{ value, dataKey }">
        <th :key="dataKey">
          <NrTooltip :label="value" v-if="value">
            <a v-if="legacyRequestShowPage" :href="`/requests/${value}`">{{
              value
            }}</a>
            <router-link v-else :to="`/requests/${value}`">
              {{ value }}
            </router-link>
          </NrTooltip>
        </th>
      </template>

      <template v-slot:request_state="{ value, column, dataKey }">
        <td :key="dataKey">
          <NrIcon
            :name="getStateIcon(column, value).name"
            :class="[getStateIcon(column, value).color, 'status-icon']"
          />
        </td>
      </template>

      <template v-slot:requester_name="{ value, column, dataKey }">
        <td :key="dataKey">
          <NrTooltip v-if="value" :label="value">
            {{ truncate(value, { length: column.maxChar }) }}
          </NrTooltip>
        </td>
      </template>

      <template v-slot:request_text="{ value, column, dataKey }">
        <td :key="dataKey">
          <NrTooltip v-if="value" :label="value">
            {{ truncate(value, { length: column.maxChar }) }}
          </NrTooltip>
        </td>
      </template>

      <template v-slot:department_names="{ value, column, dataKey }">
        <td :key="dataKey">
          <NrTooltip v-if="value" :label="value">
            {{ truncate(value, { length: column.maxChar }) }}
          </NrTooltip>
        </td>
      </template>
    </NrTable>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NrTable from '@nextrequestco/components/src/components/NrTable'
import NrTableHeader from '@nextrequestco/components/src/components/NrTableHeader'
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import togglePageScroll from '../../../mixins/toggle-page-scroll.ts'
import isEmpty from 'lodash/isEmpty'
import truncate from 'lodash/truncate'

export default {
  mixins: [togglePageScroll],

  components: {
    NrTable,
    NrTableHeader,
    NrTooltip,
    NrIcon
  },

  props: {
    height: { type: Number, default: 300 }
  },

  computed: {
    ...mapState('requests', [
      'allRequestsCount',
      'columns',
      'requests',
      'tableHeaderTitle',
      'tableHeaderTitleTooltip',
      'isLoading',
      'height'
    ]),
    ...mapState(['account', 'currentUser']),
    legacyRequestShowPage() {
      return (
        !isEmpty(this.currentUser) &&
        this.account.legacy_request_show_enabled &&
        !this.currentUser?.request_show_beta
      )
    },

    requestsTableHeight() {
      const loadedHeight = this.height + 'px'
      if (this.isSmallScreen()) return 'auto;'
      return loadedHeight
    }
  },

  methods: {
    truncate,
    ...mapActions('requests', [
      'setColumns',
      'setTableColumnsInCookie',
      'toggleFilter'
    ]),

    getStateIcon(column, actualRequestState) {
      const staffOnlyStates = ['Overdue', 'Due soon', 'Waiting for requester']
      let visibleRequestState = actualRequestState
      if (
        !this.$ability.can('read', 'staff_only_items') &&
        staffOnlyStates.includes(actualRequestState)
      ) {
        visibleRequestState = 'Open'
      }
      const name = column?.icons[visibleRequestState][0]
      const color = column?.icons[visibleRequestState][1]
      return { name, color }
    },

    async toggleColumnState(event) {
      const field = event?.column?.field
      const state = event?.columnValue
      try {
        await this.setColumns(
          this.columns.map((column) => {
            return {
              ...column,
              hidden: column.field === field ? !state : column.hidden
            }
          })
        )

        this.setTableColumnsInCookie(this.columns)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (_err) {}
    }
  }
}
</script>

<style scoped lang="scss">
.requests-table {
  height: v-bind(requestsTableHeight);
}
</style>
